import { render, staticRenderFns } from "./ExAssignmentType.vue?vue&type=template&id=e4dba398"
import script from "./ExAssignmentType.vue?vue&type=script&lang=js"
export * from "./ExAssignmentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports